/**
 * Tipo de comparação de uma faixa do limite condicional, aplicada ao valor do parâmetro de referência.
 * BETWEEN é aberto no menor valor e fechado no maior: value < x <= valueTo.
 */
export enum RegulationComparisonEnum {
    LESS_OR_EQUAL = 'LESS_OR_EQUAL',
    GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
    LESS = 'LESS',
    GREATER = 'GREATER',
    BETWEEN = 'BETWEEN',
    EQUAL = 'EQUAL',
}

export enum RegulationComparisonLabelEnum {
    LESS_OR_EQUAL = 'Menor ou igual a',
    GREATER_OR_EQUAL = 'Maior ou igual a',
    LESS = 'Menor que',
    GREATER = 'Maior que',
    BETWEEN = 'Entre dois valores',
    EQUAL = 'Igual a',
}
